import { render } from "./InputAddress.vue?vue&type=template&id=c626f0b4"
import script from "./InputAddress.vue?vue&type=script&lang=js"
export * from "./InputAddress.vue?vue&type=script&lang=js"

import "./InputAddress.vue?vue&type=style&index=0&id=c626f0b4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__